//test
export const getMsgCount = state => {
    return state.msgCount
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js